import React, { useState } from "react";
import "./Options.css";
import {
  undo,
  redo,
  info,
  CreditBtnIcon,
  SyncNav,
} from "../../../assets/icons";
import { RoleName, NameOnly, Songs, Logos, Blurb } from "./OptionBlocks";
import { useSelector, useDispatch } from "react-redux";
import {
  redoOptions,
  saveProjectGlobalOption,
  undoOptions,
  updateProjectCredits,
  updateProjectCreditsByGoogle,
} from "../../../Redux/actions/projectActions";
import OptionFont from "./OptionFont/OptionFont";
import { selectedOption } from "../../../Redux/actions/projectActions";
import { useNavigate } from "react-router-dom";
import ScreenOption from "../Cards/components/ScreenOption";
// import Button from "../../../Components/Button/Button_2";
import { toast } from "react-toastify";
import CustomToast, {
  customToatStyle,
  customToatStyleError,
} from "../../../Components/CustomToast/CustomToast";
import { read, utils } from "xlsx";
import { excelDataToCredits } from "../../../services/excelDataToProjectData";
import { Button } from "../../../Components";
import { AiOutlineGlobal } from "react-icons/ai";

const getBlockName = (blockType) => {
  switch (blockType?.toLowerCase()) {
    case "rolename":
      return "Role + Name";
    case "nameonly":
      return "Name Only";
    case "logo":
      return "Logos";
    case "blurb":
      return "Blurb";
    case "song":
      return "Songs";
    default:
      return "Name Only";
  }
};

const getOptionBlock = (
  options,
  currentBlockIdx,
  currentBlockId,
  undoStack,
  setReLoading,
  isCard
) => {
  switch (options.block_type?.toLowerCase()) {
    case "rolename":
      return (
        <RoleName
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
    case "nameonly":
      return (
        <NameOnly
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
    case "logo":
      return (
        <Logos
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
          setReLoading={setReLoading}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
    case "blurb":
      return (
        <Blurb
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
    case "song":
      return (
        <Songs
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
    default:
      return (
        <NameOnly
          options={options}
          currentBlockIdx={currentBlockIdx}
          currentBlockId={currentBlockId}
          undoStack={undoStack}
          isCard={isCard === undefined || !isCard ? false : true}
        />
      );
  }
};

const getUpdatedProjectCredits = (currentCredits, newCredits) => {
  try {
    const updatedCredits = newCredits;
    for (let i = 0; i < newCredits.length; i++) {
      let idx = currentCredits.findIndex(
        (credit) =>
          credit.options.block_name == newCredits[i].options.block_name
      );
      if (
        idx !== -1 &&
        currentCredits[idx].options.block_type ==
          newCredits[i].options.block_type
      ) {
        updatedCredits[i].options = currentCredits[idx].options;
      }
    }
    return { data: updatedCredits };
  } catch (error) {
    return { error, data: null };
  }
};

const Options = ({
  currentBlockOptions,
  currentBlockIdx,
  currentBlockId,
  setReLoading,
  isOptionSelected,
  isCard,
}) => {
  const [selected, setSelected] = useState("options");
  const [renderOpen, setRenderOpen] = useState(false);
  const [blockName, setBlockName] = useState(currentBlockOptions.block_type);
  const objectMap = useSelector((state) => state.undoRedo);
  const undoStack = objectMap[currentBlockIdx]?.obj;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const id = "66e14a11eedf1bfc39f94b39";

  const OptionHandler = (val) => {
    dispatch(selectedOption(val));
  };

  const {
    googleSheetLink,
    _id,
    googleSpreadSheetId,
    credits: currentCredits,
    currentBlock,
  } = useSelector((state) => state?.project);

  const handleGoogleUpdate = async () => {
    await setReLoading({ condn: true, label: "Syncing..." });

    try {
      const res = await dispatch(
        updateProjectCreditsByGoogle(
          _id,
          googleSpreadSheetId,
          currentCredits,
          isCard
        )
      );
      if (res?.success === true) {
        await setReLoading({ condn: false, label: "" });
        setTimeout(() => {
          toast(
            <CustomToast title="" content={res?.message} />,
            customToatStyle
          );
        }, 300);
      } else {
        await setReLoading({ condn: false, label: "" });
        setTimeout(() => {
          toast(
            <CustomToast
              title={res?.response?.data?.title}
              content={res?.response?.data?.message}
            />,
            customToatStyleError
          );
        }, 2000);
      }
    } catch (err) {
      await setReLoading({ condn: false, label: "" });
    }
  };

  const handleFileInput = (file) => {
    try {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const binaryStr = evt.target.result;
        const wb = read(binaryStr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const jsonData = utils.sheet_to_json(ws, { header: 1 });
        const newCredits = excelDataToCredits(jsonData);
        const { data: updatedCredits, error } = getUpdatedProjectCredits(
          currentCredits,
          newCredits
        );
        if (error) {
          return error;
        }
        dispatch(updateProjectCredits(_id, updatedCredits));
      };
      reader.readAsBinaryString(file);
    } catch (err) {
      return err;
    }
  };

  // Function to apply settings to all scroll
  const applyToAll = () => {
    dispatch(
      saveProjectGlobalOption(
        currentBlockId,
        currentBlockOptions,
        currentBlockOptions.block_type,
        isCard
      )
    );
    toast(
      <CustomToast title="" content={`Changes applied to all ${currentBlockOptions.block_type} blocks.`} />,
      customToatStyle
    );
  };

  return (
    <div className="OptionContainer">
      <div className="optionHdr">
        <div className="Layout">
          <div className="Layout-title">
            <div className={isCard ? `Layout-titleBlkCrd` : `Layout-titleBlk`}>
              <div
                className={
                  "layout-text " + (selected === "options" ? "selected" : "")
                }
                onClick={() => {
                  setSelected("options");
                  OptionHandler("layout");
                }}
              >
                Layout
              </div>

              <div
                className={
                  "layout-text " + (selected === "fonts" ? "selected" : "")
                }
                onClick={() => {
                  setSelected("fonts");
                  OptionHandler("font");
                }}
              >
                Font
              </div>

              {isCard && (
                <div
                  className={
                    "layout-text " + (selected === "screen" ? "selected" : "")
                  }
                  onClick={() => {
                    setSelected("screen");
                    OptionHandler("screen");
                  }}
                >
                  Screen
                </div>
              )}
            </div>

            {/* <div className="undo-redo">{objectMap[currentBlockIdx]?.obj && (
              <><button disabled={undoStack.getPosition < 1} onClick={() => dispatch(undoOptions(currentBlockId))}><img src={undo} alt="" /></button>
                <button disabled={ undoStack.getPosition === -1 || undoStack.getPosition === undoStack.getData.length - 1} onClick={() => dispatch(redoOptions(currentBlockId))}>
                  <img src={redo} alt="" style={{ color: "white" }} />
                </button></>)}
            </div> */}
          </div>

          <div className="Layout-screen">
            <div className="Block-type">
              {selected !== "screen" && (
                <div className="Block-text">
                  <span>Block type</span>
                </div>
              )}
              <div
                className={
                  selected === "screen" ? "crdBlock-name" : "Block-name"
                }
              >
                {selected !== "screen" && (
                  <div
                    className={{
                      marginLeft: selected === "fonts" ? "10px" : "",
                    }}
                  >
                    <span>{getBlockName(currentBlockOptions.block_type)}</span>
                  </div>
                )}
                {selected === "screen" && (
                  <div className="">
                    <p>Card {currentBlockIdx + 1}</p>
                  </div>
                )}
                {selected === "fonts" ? (
                  <div>
                    <img
                      className="w-[18px] cursor-pointer"
                      src={info}
                      alt=""
                      onClick={() =>
                        window.open(`/help/66fd235c676b1a05d82daf44`)
                      }
                    />
                  </div>
                ) : selected === "screen" ? (
                  <div>
                    <img
                      className="w-[18px] cursor-pointer"
                      src={info}
                      alt=""
                      onClick={() => window.open(`/help/`)}
                    />
                  </div>
                ) : (
                  <div>
                    <img
                      className="w-[18px] cursor-pointer"
                      src={info}
                      alt=""
                      onClick={() =>
                        window.open(`/help/66fd093d676b1a05d82daadc`)
                      }
                    />
                  </div>
                )}
              </div>
            </div>
            <hr className="optionHrLine"/>
            
            {selected === "options" ? (
              <div className="Mainlayout-screen">
                <div>
                {getOptionBlock(
                  currentBlockOptions,
                  currentBlockIdx,
                  currentBlockId,
                  undoStack,
                  setReLoading,
                  isCard
                )}
              </div>

              <div className="h-[52px] mb-[25px] flex justify-start items-center max-w-full ">
                <div className="optionSectionLabel">Global Settings</div>
                <div className="optionSectionContent2">
                  <button
                onClick={applyToAll}
                className="flex justify-between text-white items-center GlobalBtn  px-3 py-1.5 bg-[#222222] hover:bg-[#444444] rounded-md border-[1px] border-[#808080] text-sm w-[130px]"
              >
                <AiOutlineGlobal className="text-[1rem]" />
                Apply to all
              </button>
                </div>
              
            </div>
              </div>
            ) : selected === "screen" ? (
            
               <div className="Mainlayout-screen">
                <ScreenOption
                  currentBlockOptions={currentBlockOptions}
                  currentBlockIdx={currentBlockIdx}
                  currentBlockId={currentBlockId}
                  isCard={isCard}
                />
              </div>
              
            ) : (
              <div className="Mainlayout-screen">
                <OptionFont isCard={isCard} />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="optionFtr">
        <Button
          type="button"
          buttonStyle="btn--solid"
          buttonSize="btn--size"
          onClick={() => window.open(googleSheetLink)}
          bgColor={"#373843"}
          customWidth={"49%"}
        >
          <p className="flex justify-center items-center p-0">
            <img className="ftr-btn" src={CreditBtnIcon} alt="" />
            <span className="">Credit Sheet</span>
          </p>
        </Button>

        {googleSheetLink ? (
          <Button
            type="button"
            buttonStyle="btn--solid"
            buttonSize="btn--size"
            onClick={handleGoogleUpdate}
            bgColor={"#373843"}
            customWidth={"49%"}
          >
            <p className="flex justify-center items-center p-0">
              <img className="ftr-btn" src={SyncNav} alt="" />
              <span>Sync Credits</span>
            </p>
          </Button>
        ) : (
          <Button
            type="button"
            buttonStyle="btn--solid"
            buttonSize="btn--size"
            handleFileInput={handleFileInput}
            bgColor={"#373843"}
            customWidth={"49%"}
          >
            <p className="flex justify-center items-center p-0">
              <img className="ftr-btn" src={SyncNav} alt="" />
              <span>Sync Credits</span>
            </p>
          </Button>
        )}
      </div>
    </div>
  );
};

export default Options;
